export const graphqlClientConfig = {
  urlEndpoint: process.env.REACT_APP_APPSYNC_URL || 'https://rx4jwir7mrctzgak5t2zdugqbq.appsync-api.eu-west-1.amazonaws.com/graphql',
  awsRegion: 'eu-west-1',
};
